export default __webpack_public_path__ + "static/media/img-3.1b1b3795.png";